<template>
  <div class="patient-payment-new">
    <payment-new
      :medicalPaymentOriginalId="medicalPaymentOriginalId"
      @cancel="goToListPage"
    />
  </div>
</template>

<script>
import PaymentNew from '@/components/main_contents/payments/PaymentNew'
import { mapGetters } from 'vuex'

export default {
  name: 'PatientPaymentNew',

  components: {
    PaymentNew
  },

  props: {
    ownerId: { type: Number },
    patientId: { type: Number },
    medicalPaymentOriginalId: { type: Number, required: true }
  },

  computed: {
    ...mapGetters({ socketConnectCounts: 'auth/socketConnectCounts' })
  },

  watch: {
    socketConnectCounts() {
      /*
       GAE環境だとsocketの接続してから１時間経過すると接続が強制的に切断される(その後すぐに自動的に再接続される)。切断時に開いているカルテのロック情報が削除され(plus_socketのdisconnect処理内)、別端末で警告なしでカルテが開けてしまう不具合があった。それを防ぐため、socketの再接続時に開いているカルテに再度ロックを掛けるようにしている。
       該当の不具合のチケット→http://153.127.52.67/redmine/issues/15
      */
      const lockParams = this.getLockParams()
      this.$store.dispatch('auth/lockKarte', lockParams)
    }
  },

  methods: {
    getLockParams() {
      const medicalPayment = this.$store.getters[
        'medicalPayments/getDataByOriginalId'
      ](this.medicalPaymentOriginalId)
      const hospitalizations =
        this.$store.getters['hospitalizations/getDataByPatientId'](
          medicalPayment.patientId
        ) ?? []
      const hospitalization = hospitalizations.find(v =>
        v.medicalPaymentOriginalIds.includes(medicalPayment.originalId)
      )
      const lockParams = {
        patientId: 0,
        medicalRecordOriginalId: medicalPayment.medicalRecordOriginalId,
        hospitalizationId: hospitalization?.id || 0
      }
      return lockParams
    },
    goToListPage() {
      this.$router.push({
        name: 'patient-payments',
        params: { ownerId: this.ownerId, patientId: this.patientId }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.patient-payment-new {
  width: 100%;
}
</style>
